import { createSelector } from 'reselect';
import { enabledSelector } from 'selectors/testTarget/offers/homepageCarouselRatings/enabled/enabledSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

/**
 * Returns true when Adobe Target is ready and the `homepageCarouselRatings` offer is enabled.
 */
const showHomepageCarouselRatingsSelector = createSelector(isTestTargetReadySelector, enabledSelector, (testReady, enabled) => testReady && enabled);

export { showHomepageCarouselRatingsSelector };
